import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../services/api'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi();
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            categories: [],
            additionalTypes: [],
            showMemberShipForProgram: CONFIG_COMPANY.SHOW_MEMBERSHIP_FOR_PROGRAMS != null ? CONFIG_COMPANY.SHOW_MEMBERSHIP_FOR_PROGRAMS : false,
            paymentTypes: {
                STANDARD: {
                    id: 1,
                    label: LocService.t('label_standard_payment'),
                    value: false
                },
                ADDITIONAL_SERVICE: {
                    id: 2,
                    label: LocService.t('label_additional_payment'),
                    value: true
                },
            },
            membershipTypes: [
                {
                    id: 'SUBSCRIPTION',
                    label: LocService.t('label_membership_subscription'),
                },
                {
                    id: 'ONE_TIME_PAYMENT',
                    label: LocService.t('label_membership_one_payment'),
                },
                {
                    id: 'ONE_TIME_PAYMENT_AND_SUBSCRIPTION',
                    label: LocService.t('label_membership_both'),
                }
            ],
            showMembershipType: false,
            model: {
                orderNumber: 0,
                name: '',
                durationInDays: 1,
                trainingNumber: 0,
                price: 0,
                additionalKit: null,
                category: null,
                types: CONFIG_COMPANY.DEFAULT_TRAINING_TYPES,
                additionalService: false,
                enableAction: false,
                forProgram: false,
                membershipType: null
            },
            kits: [],
            allKits: [],
            types: [],

        }
    },
    methods: {
        addMembershipsPackage: addMembershipsPackage,
        getMembershipsCategories: getMembershipsCategories,
        getAdditionalKits: getAdditionalKits,
        openTrainingTypes: openTrainingTypes,
        openAddMembershipCategory: openAddMembershipCategory,
        getTrainingTypes: getTrainingTypes,
        setSelectedCheckBox: setSelectedCheckBox,
        openAdditionalKit: openAdditionalKit,
        onChangeCheckBox: onChangeCheckBox,
        onChangeCheckBoxKits: onChangeCheckBoxKits,
        getChipTypeClass: getChipTypeClass,
        setSelectedCheckBoxKits: setSelectedCheckBoxKits,
        isSelectedType: isSelectedType,
        generateKits: generateKits,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }

        if(session.getConfig().additionalServiceTypes != null && session.getConfig().additionalServiceTypes.length > 0){
            this.additionalTypes = session.getConfig().additionalServiceTypes.split(";").filter(e => e.length > 0)
        }

        if(session.getConfig().enableSubscriptionModel != null){
            this.showMembershipType = session.getConfig().enableSubscriptionModel;
        }

        this.model.userId = this.$route.query.id;
        this.getTrainingTypes()
        this.getAdditionalKits()
        this.getMembershipsCategories()
    }
}

function getMembershipsCategories(){
    let _self = this;
    AdminApiService.getMembershipsCategories()
        .then((response) => {
           _self.categories = response.data;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function addMembershipsPackage() {
    let _self = this;
    if(_self.model.types.length === 0){
        swal(LocService.t("label_error"),LocService.t('label_payment_error_choose_type'), 'error')
        return;
    }
    _self.model.orderNumber = _self.model.orderNumber <= 0 ? null : _self.model.orderNumber;
    _self.model.additionalKit = this.generateKits();
    _self.model.durationInDays = parseInt(_self.model.durationInDays)
    _self.model.trainingNumber = parseInt(_self.model.trainingNumber)
    _self.model.types = _self.model.types.filter(e => e.length > 0)
    AdminApiService.addMembershipsPackage(_self.model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_payment_success_add'), 'success')
            this.$router.push('/membership-packages');
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}
function generateKits(){
    if(this.kits.length === 0) return '';
    var i = 0;
    var kit = '';
    for(i = 0; i < this.kits.length; i++){
        kit = kit + this.kits[i] + ';'
    }
    return kit;
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
        })
        .catch(error => {
            console.log(error)
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getAdditionalKits(){
    let _self = this;
    AdminApiService.getAdditionalKit()
        .then((response) => {
            _self.allKits = response.data;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function onChangeCheckBox(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.model.types.indexOf(key) < 0){
            this.model.types.push(key);
        }
    }else{
        const index = this.model.types.indexOf(key);
        if (index > -1) {
            this.model.types.splice(index, 1);
        }
    }
}

function onChangeCheckBoxKits(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.kits.indexOf(key) < 0){
            this.kits.push(key);
        }
    }else{
        const index = this.kits.indexOf(key);
        if (index > -1) {
            this.kits.splice(index, 1);
        }
    }
}

function setSelectedCheckBox(key) {
    return this.model.types.indexOf(key) > -1
}

function setSelectedCheckBoxKits(key) {
    return this.kits.indexOf(key) > -1
}

function openAdditionalKit(){
    this.$router.push('additional-kits')
}


function openTrainingTypes(){
    this.$router.push('training-types')
}

function openAddMembershipCategory(){
    this.$router.push('add-membership-category')
}


function getChipTypeClass(item){
    if(this.model.additionalService === item.value) return 'chip-selected';
    return 'chip-unselected';
}

function isSelectedType(item){
    return this.model.additionalService === item.value;
}




// WEBPACK FOOTER //
// ./src/components/Membership/AddMembership/AddMembershipPackage.js